"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ObjectId = require('bson').ObjectID;

var clone = require('clone');

var tv4 = require('tv4');

var Card = require('./card');

var ContactPerson = require('../core/contact-person');

var InspectCard = /*#__PURE__*/function (_Card) {
  _inherits(InspectCard, _Card);

  var _super = _createSuper(InspectCard);

  function InspectCard(opt) {
    var _this;

    _classCallCheck(this, InspectCard);

    _this = _super.call(this, opt);
    _this.type = 'INSPECT';
    _this.details = {
      partyType: null,
      partyId: null,
      partyName: null,
      memberId: null,
      memberName: null,
      buildingId: null,
      buildingName: null,
      floorId: null,
      floorName: null,
      people: []
    };

    if (opt && opt.details) {
      _this.fillObject(clone(opt.details));
    }

    return _this;
  }

  _createClass(InspectCard, [{
    key: "fillObject",
    value: function fillObject(details) {
      this.details.partyType = details.partyType || null;
      this.details.partyId = details.partyId ? new ObjectId(details.partyId) : null;
      this.details.partyName = details.partyName || null;
      this.details.memberId = details.memberId ? new ObjectId(details.memberId) : null;
      this.details.memberName = details.memberName || null;
      this.details.buildingId = details.buildingId || null;
      this.details.buildingName = details.buildingName || null;
      this.details.floorId = details.floorId || null;
      this.details.floorName = details.floorName || null;
      this.details.people = details.people ? details.people.map(function (item) {
        return new ContactPerson(item);
      }) : [];
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      var _JSON$parse = JSON.parse(JSON.stringify(this.details)),
          partyType = _JSON$parse.partyType,
          partyId = _JSON$parse.partyId,
          partyName = _JSON$parse.partyName,
          memberId = _JSON$parse.memberId,
          memberName = _JSON$parse.memberName;

      return {
        partyType: partyType,
        partyId: partyId,
        partyName: partyName,
        memberId: memberId,
        memberName: memberName
      };
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, InspectCard.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'inspect-card.schema.json',
        type: 'object',
        allOf: [{
          $ref: 'card.schema.json'
        }, {
          properties: {
            details: {
              partyType: {
                type: ['string', 'null']
              },
              partyId: {
                type: ['object', 'null']
              },
              partyName: {
                type: ['string', 'null']
              },
              memberId: {
                type: ['object', 'null']
              },
              memberName: {
                type: ['string', 'null']
              },
              buildingId: {
                type: ['string', 'null']
              },
              floorId: {
                type: ['string', 'null']
              },
              buildingName: {
                type: ['string', 'null']
              },
              floorName: {
                type: ['string', 'null']
              },
              people: {
                type: 'array',
                item: {
                  $ref: 'contact-person.schema.json'
                }
              }
            }
          }
        }],
        required: Object.keys(this)
      };
    }
  }]);

  return InspectCard;
}(Card);

tv4.addSchema(Card.schema());
tv4.addSchema(ContactPerson.schema());
module.exports = InspectCard;